import React, { FC } from 'react';
import { SpacingLayout } from 'components/atoms';
import { TermsOfUse } from 'templates/company';
import { SEO } from 'templates/layout';

const Terms: FC = () => {
  return (
    <SpacingLayout>
      <SEO title={'Terms Of Use'} />
      <TermsOfUse />
    </SpacingLayout>
  );
};

export default Terms;
